class BackgroundVideo extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const video = this.querySelector('video');
    if (!video) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const applyMotion = () => {
      if (motion.matches) video.pause();
      else video.play().catch(() => {});
    };
    motion.addEventListener('change', applyMotion, { signal: this.controller.signal });
    applyMotion();
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
}
customElements.define('s-background-video', BackgroundVideo);
